/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateSprofileKeyvalPayload } from '../model/createSprofileKeyvalPayload';
import { SprofileData } from '../model/sprofileData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SprofileService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a keyval related to the signature profile for a step
     * 
     * @param stepId Step on which it applied
     * @param sprofileCode Key to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSprofileKeyvalVal(stepId: number, sprofileCode?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSprofileKeyvalVal(stepId: number, sprofileCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSprofileKeyvalVal(stepId: number, sprofileCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSprofileKeyvalVal(stepId: number, sprofileCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling deleteSprofileKeyvalVal.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<any>(`${this.basePath}/api/sprofiles/steps/${encodeURIComponent(String(stepId))}/keys-values`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of sprofiles keyval keys with possible values
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSprofileKeyvalList(observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: Array<string>; }>;
    public getSprofileKeyvalList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: Array<string>; }>>;
    public getSprofileKeyvalList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: Array<string>; }>>;
    public getSprofileKeyvalList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: Array<string>; }>(`${this.basePath}/api/sprofiles/keys`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of sprofiles keyval values
     * 
     * @param stepId Step on which it applied
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSprofileKeyvalValList(stepId: number, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: { [key: string]: string; }; }>;
    public getSprofileKeyvalValList(stepId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: { [key: string]: string; }; }>>;
    public getSprofileKeyvalValList(stepId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: { [key: string]: string; }; }>>;
    public getSprofileKeyvalValList(stepId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling getSprofileKeyvalValList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<{ [key: string]: { [key: string]: string; }; }>(`${this.basePath}/api/sprofiles/steps/${encodeURIComponent(String(stepId))}/keys-values`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of sprofiles
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSprofileList(observe?: 'body', reportProgress?: boolean): Observable<Array<SprofileData>>;
    public getSprofileList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SprofileData>>>;
    public getSprofileList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SprofileData>>>;
    public getSprofileList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SprofileData>>(`${this.basePath}/api/sprofiles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set a keyval on a signature profile for a step
     * 
     * @param stepId Step on which it applied
     * @param payload Key value to be created
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setSprofileKeyvalVal(stepId: number, payload?: CreateSprofileKeyvalPayload, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setSprofileKeyvalVal(stepId: number, payload?: CreateSprofileKeyvalPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setSprofileKeyvalVal(stepId: number, payload?: CreateSprofileKeyvalPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setSprofileKeyvalVal(stepId: number, payload?: CreateSprofileKeyvalPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stepId === null || stepId === undefined) {
            throw new Error('Required parameter stepId was null or undefined when calling setSprofileKeyvalVal.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/sprofiles/steps/${encodeURIComponent(String(stepId))}/keys-values`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
